
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  toc: true,
  description: 'Learn more about the Plaid Postman Collection, which allows you to send API requests without code',
  preloadImages: [{
    src: '/assets/img/docs/quickstart/plaid-postman.png',
    type: 'image/webp'
  }]
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const YouTubeEmbed = makeShortcode("YouTubeEmbed");
const Image = makeShortcode("Image");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Plaid Postman Collection' subtitle={metadata.description} mdxType="Header" />
    <h4 {...{
      "id": "introduction"
    }}>{`Introduction`}</h4>
    <div>
  <YouTubeEmbed videoId='f4NhgHpp5aA' alignment='right' title='Plaid and Postman in 3 minutes' mdxType="YouTubeEmbed" />
      <p>{`Interested in experimenting with the Plaid API without having to write a full-stack
application? Plaid offers a `}<a parentName="p" {...{
          "href": "https://github.com/plaid/plaid-postman"
        }}>{`Postman Collection`}</a>{` as
a convenient tool for exploring Plaid API endpoints without writing code. The
Postman Collection provides pre-formatted requests for almost all of Plaid's API
endpoints that you can call from their desktop application or a web browser. All
you have to do is fill in your API keys and any arguments.`}</p>
    </div>
    <p>{`To get started using the Postman collection, you will need a Plaid account with
access to the Sandbox environment, an account at `}<a parentName="p" {...{
        "href": "https://www.postman.com"
      }}>{`Postman.com`}</a>{`, and (optionally)
the Postman `}<a parentName="p" {...{
        "href": "https://www.postman.com/downloads/"
      }}>{`desktop application`}</a>{`.
Once you have all the prerequisites, visit our `}<a parentName="p" {...{
        "href": "https://github.com/plaid/plaid-postman"
      }}>{`GitHub page`}</a>{`
and click the "Run in Postman" button to load up the Plaid collection of endpoints.`}</p>
    <p>{`To skip creating a Postman account, use the API explorer in `}<a parentName="p" {...{
        "href": "/docs/sandbox/studio/"
      }}>{`Sandbox Studio`}</a>{` instead.`}</p>
    <Image src='/assets/img/docs/quickstart/plaid-postman.png' alt="Postman interface showing Plaid API call setup for 'Retrieve Auth' with JSON body and response displaying account details." width='624' mdxType="Image" />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "introduction",
        level: 4,
        title: "Introduction",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
